import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const MenuBurgerIcon = React.memo(function MenuBurgerIcon(props: TMenuBurgerIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Menu" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 4.5C21 4.77614 20.7761 5 20.5 5H1.5C1.22386 5 1 4.77614 1 4.5V3.5C1 3.22386 1.22386 3 1.5 3H20.5C20.7761 3 21 3.22386 21 3.5V4.5ZM21 11.5C21 11.7761 20.7761 12 20.5 12H1.5C1.22386 12 1 11.7761 1 11.5V10.5C1 10.2239 1.22386 10 1.5 10H20.5C20.7761 10 21 10.2239 21 10.5V11.5ZM20.5 19C20.7761 19 21 18.7761 21 18.5V17.5C21 17.2239 20.7761 17 20.5 17H1.5C1.22386 17 1 17.2239 1 17.5V18.5C1 18.7761 1.22386 19 1.5 19H20.5Z"
            />
        </IconBase>
    );
});

export default MenuBurgerIcon;

// #region Types

export type TMenuBurgerIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <MenuBurgerIcon /> : { ...IconBaseExample, render: MenuBurgerIcon };

// #endregion
